// Tab strips, and tables wider than the screen, scroll sideways on phones (styles.css). While content sits past an edge the box gets
// data-more (right) or data-less (left), and experience.css fades that edge, so a cut-off
// tab reads as "more" instead of as a broken label. SectionTabs sets data-more for itself.
const STRIPS = '.tabs, .pl-tabs, .tr-tabs, .tr-views, .callcenter-tabs, .category-tabs, .queue-statuses, .workflow-tabs, .client-settings-tabs, .table-wrap, .q-grid-wrap, .portal-table-wrap';

export function watchTabStrips() {
  if (typeof window === 'undefined' || typeof ResizeObserver === 'undefined' || typeof MutationObserver === 'undefined') return;
  const seen = new Set<HTMLElement>();
  const measure = (el: HTMLElement) => {
    const more = el.scrollLeft + el.clientWidth < el.scrollWidth - 1;
    const less = el.scrollLeft > 1;
    if (more) el.setAttribute('data-more', ''); else el.removeAttribute('data-more');
    if (less) el.setAttribute('data-less', ''); else el.removeAttribute('data-less');
  };
  const sizes = new ResizeObserver((entries) => { for (const entry of entries) measure(entry.target as HTMLElement); });
  const attach = (el: HTMLElement) => {
    if (seen.has(el)) return;
    seen.add(el);
    sizes.observe(el);
    el.addEventListener('scroll', () => measure(el), { passive: true });
    measure(el);
  };
  let queued = 0;
  const scan = () => {
    queued = 0;
    for (const el of document.querySelectorAll<HTMLElement>(STRIPS)) attach(el);
    // Tabs appear and change after data loads: re-measure every strip, not only new ones.
    for (const el of seen) { if (el.isConnected) measure(el); else seen.delete(el); }
  };
  scan();
  new MutationObserver(() => { if (!queued) queued = window.requestAnimationFrame(scan); }).observe(document.body, { childList: true, subtree: true });
}
